import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import clienteService from "../services/clienteService";
import { message } from "utils/Funciones";

const initialState = {
    isMutation: { success: false, error: false, loading: false, message: '', updated: false },
    data: [],
    dataByPage: [],
    totalRow: 0,
    totalPage: 0,
    totalStoreValue: 0
};

export const create = createAsyncThunk(
    "cliente/create",
    async (formData, thunkAPI) => {
        try {
            return await clienteService.create(formData);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const get = createAsyncThunk(
    "cliente/get",
    async (_, thunkAPI) => {
        try {
            return await clienteService.get();
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getByPage = createAsyncThunk(
    "cliente/getByPage/bypage",
    async (query, thunkAPI) => {
        try {
            return await clienteService.getByPage(query);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const del = createAsyncThunk(
    "cliente/del",
    async (_id, thunkAPI) => {
        try {
            return await clienteService.del(_id);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const clienteSlice = createSlice({
    name: "cliente",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.isMutation = { success: false, error: false, loading: false, message: '', updated: false }
        },

        UPDATE_CLIENTE_FROM_SOCKET(state, action) {


        },
    },
    extraReducers: (builder) => {
        builder
            // CREATE
            .addCase(create.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(create.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
                state.isMutation.message = action.payload.message;
            })
            .addCase(create.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
            // GET
            .addCase(get.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(get.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.data = action.payload.data;
            })
            .addCase(get.rejected, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.message = action.payload;
            })
            // GET_BYPAGE
            .addCase(getByPage.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(getByPage.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.dataByPage = action.payload.data;
                state.totalPage = action.payload.totalPage;
                state.totalRow = action.payload.totalRow;
            })
            .addCase(getByPage.rejected, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.message = action.payload;
            })

            // DELETE
            .addCase(del.pending, (state) => {
                state.isMutation.loading = true;
            })
            .addCase(del.fulfilled, (state, action) => {
                state.isMutation.loading = false;
                state.isMutation.success = true;
                state.isMutation.message = action.payload.message;
            })
            .addCase(del.rejected, (state, action) => {
                state.isMutation.loading = false;
            })
    },
});

export const { UPDATE_CLIENTE_FROM_SOCKET, SET_TO_DEFAULT_RESPONSE } = clienteSlice.actions;

export default clienteSlice.reducer;

